// Copyright (c) 2017 Deere & Company

import auditRecording from './audit-recording';
import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import fullDebitItemToUpdate from './full-debit-item-to-update';
import isConfirmationModalVisible from './confirmation-modal';
import isFullDebitModalVisible from './full-debit-modal';
import isRecordAuditModalVisible from './is-record-audit-modal-visible';

export const getCombinedReducers = () => combineReducers({
    auditRecording,
    busyCounter,
    fullDebitItemToUpdate,
    isConfirmationModalVisible,
    isFullDebitModalVisible,
    isRecordAuditModalVisible
});



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/reducers/index.js